import * as React from 'react';
import useEventCallback from '../utils/use_event_callback';
export default function useActiveState(_ref) {
  var {
    disabled,
    onBlur,
    onKeyDown,
    onKeyUp,
    onMouseDown,
    onMouseUp,
    onTouchEnd,
    onTouchStart
  } = _ref;
  var [isActive, setActive] = React.useState(false);
  if (disabled && isActive) {
    setActive(false);
  }
  var handleBlur = useEventCallback(event => {
    if (isActive) {
      setActive(false);
    }
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
  });
  var handleMouseDown = useEventCallback(event => {
    if (!isActive && event.button === 0 && !disabled) {
      setActive(true);
    }
    onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(event);
  });
  var handleMouseUp = useEventCallback(event => {
    if (isActive && !disabled) {
      setActive(false);
    }
    onMouseUp === null || onMouseUp === void 0 ? void 0 : onMouseUp(event);
  });
  var handleKeyDown = useEventCallback(event => {
    if (!isActive && event.key === ' ' && !disabled) {
      setActive(true);
    }
    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
  });
  var handleKeyUp = useEventCallback(event => {
    if (event.key === ' ' && !disabled) {
      setActive(false);
    }
    onKeyUp === null || onKeyUp === void 0 ? void 0 : onKeyUp(event);
  });
  var handleTouchStart = useEventCallback(event => {
    if (!isActive && !disabled) {
      setActive(true);
    }
    onTouchStart === null || onTouchStart === void 0 ? void 0 : onTouchStart(event);
  });
  var handleTouchEnd = useEventCallback(event => {
    if (!disabled) {
      setActive(false);
    }
    onTouchEnd === null || onTouchEnd === void 0 ? void 0 : onTouchEnd(event);
  });
  return {
    isActive,
    onBlur: handleBlur,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    onMouseDown: handleMouseDown,
    onMouseUp: handleMouseUp,
    onTouchEnd: handleTouchEnd,
    onTouchStart: handleTouchStart
  };
}